// Owner in P4: piece 8 "desk-import" (docs/FILE-OWNERSHIP.md, "The P4 pieces").
// The feature's entry file (docs/CONTRACTS.md sections 16 and 22.6): `/desk`, one lazy chunk, the import screen (24.8). The entry is
// `ownerOnly`; the route and the API refuse a member on their own. Paths carry ids and codes only (section 5).
import { createRoute, lazyRouteComponent } from '@tanstack/react-router'
import { FileInput } from 'lucide-react'
import type { Feature } from '../feature.ts'

export const feature: Feature = {
  app: (parent) => [createRoute({ getParentRoute: () => parent, path: '/desk', component: lazyRouteComponent(() => import('./DeskScreen.tsx')) })],
  nav: [{ to: '/desk', label: 'nav.desk', icon: FileInput, group: 'system', ownerOnly: true }],
}
